<template lang="pug">
#EnterpriseDeptDocfileTable
  el-upload( :accept="accept" :action="actionUrl" :before-upload="handleBeforeUpload"
    :file-list="fileList" :headers="Token" :on-error="handleError"
    :on-success="handleAvatarSuccess" ref="gentlyUpload" :show-file-list="false" style="height: 0;" )
    el-button#gentlyBtn(size="small" style="display:none;") 轻量化
  el-table.tableCol( border :data="list" empty-text height="100%"  ref="multipleTable" row-key="folderId"
    tooltip-effect="dark" @row-click="clickRow" @selection-change="selectChange" v-loading="loading")
    template(slot="empty")
      img(:src="zanwu")
      p(style="font-size:16px;color:#000;") 暂无数据
    el-table-column( align="center" type="selection" width="50" )
    el-table-column(align="center" width="50" v-slot='{row}')
      div(style="display:flex;align-items: center;justify-content: flex-end")
        span( v-if="row.isFavorite === 1" style="cursor:pointer;" @click.stop="delCol(row)" )
          img( alt="" :src="shoucang" style="margin-right: 12px;margin-top: 4px;" )
        span( v-if="row.isFavorite !== 1" style="cursor:pointer;" @click.stop="collectFile(row)" )
          img( alt="" :src="weishoucang" style="margin-right: 12px;margin-top: 4px;" )
    el-table-column( align="left" :key="16" label="文件名称" prop="folderName" ref="fileNameSort" show-overflow-tooltip v-slot='{row, $index}')
      .colCheck(style="display:flex;align-items: center")
        fileLightFlag(:row="row" @updateLight="updateLight")
        img(:src="className(row)" style="flex-shrink:0;margin:0px 5px;")
        .rechristen(v-if="isShowRechristen[$index]" @click.stop)
          el-input( v-model="rechristenCommitName" :ref="'input' + row.folderId" size="small" style="width:60%" @blur="blur" )
          el-button( size="small" style="margin-left: 5px" type="primary" @click.stop="commit(row)" ) 确定
          el-button( size="small" style="margin-left: 3px" @click.stop="isShowRechristen = []" ) 取消
        div( v-else :style="{ cursor: cacheListContent.createFolder.folderId === 'recycle' ? '' : 'pointer', }" @click.stop="clickFolderFile(row, $event)" )
          span(style="width:80%;") {{ row.folderName }}
    el-table-column( align="center" :key="15" label="操作" width="220" v-slot='{row, $index}')
      .more
        i.el.el-icon-delete.rowIcon( v-if="deleShow" title="删除" @click.stop="deleteRow(row)" )
        i.el.el-icon-edit.rowIcon(title="重命名" @click.stop="rechristen(row, $index)")
        i.el.el-icon-download.rowIcon( v-if="downShow" title="下载" @click.stop="downloadFile(row)" )
    el-table-column( align="center" :formatter="formatterFileSize" :key="11" label="文件大小" prop="fileSize" show-overflow-tooltip width="220" )
    el-table-column( align="center" :key="8" label="修改时间" prop="checkInDate" ref="upTimeSort" show-overflow-tooltip sortable width="220" v-slot='{row}')
        span {{ row.checkInDate === '1900-01-01 00:00:00' ? '' : row.checkInDate }}
  share( v-if="isShowShare" :type="6" @click-event="cancelSelect" )
  move-and-copy( v-if="perFileMoveAndCopy" :type="4" @pf3="parent2(1)" )
</template>
<script>
import { mapState } from "vuex";
import share from "@/CommonDP/components/documentRelevant/shareFile.vue";
import { filePreviewV1, tableRowIcon } from "@/CommonDP/utils/docPublic";
import docService from "@/CommonDP/service/doc-service";
import secondaryMenuService from "@/CommonDP/service/secondaryMenu-service";
import { downloadFile, downloadUrlNoPermissiontoken, gentlyUrl } from "@/CommonDP/utils";
import { getToken } from "@/CommonDP/utils";
import MoveAndCopy from "@/CommonDP/components/documentRelevant/moveAndCopy.vue";
import fileLightFlag from "@/CommonDP/components/fileLightFlag.vue";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import { UserIdentity } from "@/CommonDP/pages/mainMg/doc/common.js";
export default {
  components: { MoveAndCopy, share, fileLightFlag },
  props: {
    folderPermissions: {
      type: String,
      default: UserIdentity.ISOUT
    }
  },
  data() {
    return {
      deleAllEnterpriseDeptDoc: checkPermission(this.$allPerms.ALLENTERPRISEDEPTDOC_DELETE),
      downAllEnterpriseDeptDoc: checkPermission(this.$allPerms.ALLENTERPRISEDEPTDOC_DOWNLOAD),

      deleAffiliationEnterpriseDeptDoc: checkPermission(this.$allPerms.AFFILIATIONENTERPRISEDEPTDOC_DELETE),
      downAffiliationEnterpriseDeptDoc: checkPermission(this.$allPerms.AFFILIATIONENTERPRISEDEPTDOC_DOWNLOAD),

      rechristenCommitName: "",
      isShowRechristen: [],
      cacheListContent: {
        createFolder: {}
      },
      Token: {
        Token: getToken()
      },
      loading: false,
      actionUrl: "",
      accept: "",
      qinglianghuaList: [],
      fileList: [],
      folderId: "",
      list: [],
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      shoucang: require("@/CommonDP/assets/shoucang.png"),
      weishoucang: require("@/CommonDP/assets/weishoucang.png"),
      downShow: false,
      deleShow: false,
      timer: null, // 定时器
      keyone: 1
    };
  },
  computed: {
    ...mapState({
      isShowShare: state => state.XtDesign.isShowShare,
      currentNode: state => state.perFile.currentTreeNodeDan,
      navArr: state => state.perFile.navArrDan,
      perFileMoveAndCopy: state => state.perFile.moveAndCopy,
      jumpsta: state => state.perFile.jumpsta,
      refreshKey: state => state.perFile.refreshKey,
      refreshFolderID: state => state.perFile.refreshFolderID,
      enterpriseId: state => state.enterprise.enterpriseId,
      userInfo: state => state.user.userInfo,
      routerNav: (state) => state.router.routerNav,
      delFolderID: state => state.perFile.delFolderID
    }),
    argument() {
      return {
        folderId: "",
        isPersonal: 1,
        isRead: 1,
        priviAll: "1",
        enterpriseId: this.enterpriseId,
        noRightClickMenu: true,
        type: "",
        versionId: ""
      };
    },
    argument1() {
      return {
        folderNew: 1,
        isPersonal: 1,
        isRead: 1,
        priviAll: "1",
        enterpriseId: this.enterpriseId,
        noRightClickMenu: true,
        type: "",
        versionId: ""
      };
    }
  },
  watch: {

    navArr(newValue) {
      if (newValue) {
        this.searchFolderExpand(newValue);
      }
    },
    refreshKey(newValue, oldValue) {
      console.log("上传成功啦");
      const { folderId = "" } = this.currentNode;
      if (newValue && this.refreshFolderID === folderId) {
        this.querlist2(folderId);
      }
    },
    isShowShare(newValue) {
      if (newValue) {
        console.log(newValue, "5555");
      }
    }
  },
  // beforeDestroy() { // 页面关闭时清除定时器
  //   clearInterval(this.timer);
  //   this.timer = null;
  // },
  methods: {
    init(fileId) {
      this.folderId = fileId || this.currentNode.folderId;
      this.loading = true;
      this.queryManager();
      this.querlist2(this.folderId);
    },
    async queryManager() {
      // 如果你是管理员 就默认有全部的权限
      if (this.folderPermissions === UserIdentity.ISADIM) {
        this.downShow = true;
        this.deleShow = true;
      } else if (this.folderPermissions === UserIdentity.ISDEPT) {
        this.downShow = this.downAllEnterpriseDeptDoc || this.downAffiliationEnterpriseDeptDoc;
        this.deleShow = this.deleAllEnterpriseDeptDoc || this.deleAffiliationEnterpriseDeptDoc;
      } else {
        this.downShow = this.downAllEnterpriseDeptDoc;
        this.deleShow = this.deleAllEnterpriseDeptDoc;
      }
    },
    cancelSelect() {
      this.$refs.multipleTable.clearSelection();
    },
    async querlist(folderId = "") {
      try {
        const params = { ...this.argument1, folderId };
        const result = await secondaryMenuService.queryEnterpriseDept(params);
        if (result.result === "0") {
          const obj = result.data.find(({ folderId }) => folderId === this.folderId);
          this.$store.dispatch("perFileUpdateNavDan", [obj]);
        }
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: true,
          message: e.message || "加载失败"
        });
      }
    },
    async querlist2(folderId) {
      try {
        const params = { ...this.argument1, folderId };
        const { data = [] } = await secondaryMenuService.queryEnterpriseDept(params);
        this.list = data;
        this.loading = false;
        // if (!this.timer) {
        //   this.timer = setInterval(() => {
        //     this.timerQueryEnterpriseDept(params);
        //   }, 14000);
        // }
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: true,
          message: e.message || "加载失败"
        });
      }
    },
    async timerQueryEnterpriseDept(data) {
      try {
        const result = await secondaryMenuService.queryEnterpriseDept(data);
        if (result.result === "0") {
          this.list = result.data;
        }
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: true,
          message: e.message || "加载失败"
        });
      }
    },
    async querlist4(data) {
      try {
        const result = await docService.querySearchFolder(data);
        if (result.result === "0") {
          this.list = result.data;
        }
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: true,
          message: e.message || "加载失败"
        });
      }
    },

    // 取消收藏
    delCol(val) {
      this.$store.dispatch("perFileUpdateMessageObj", {
        isShow: true,
        message: "取消收藏中..."
      });
      const param = {
        folderId: val.folderId,
        folderName: val.folderName,
        isFolder: val.isFolder,
        prjId: ""
      };
      docService.deletePersonFavorite(param).then(res => {
        if (res.result === "0") {
          this.$store.dispatch("perFileUpdateNodeList");
          this.$message.success("取消收藏成功");
          this.querlist2(this.currentNode.folderId);
          this.$store.dispatch("perFileUpdateMessageObj", {
            isShow: false,
            message: ""
          });
        }
      });
    },

    // 收藏
    collectFile(val) {
      this.$store.dispatch("perFileUpdateMessageObj", {
        isShow: true,
        message: "收藏中..."
      });
      const param = {
        folderId: val.folderId,
        folderName: val.folderName,
        isFolder: val.isFolder,
        prjId: "EnterpriseDeptDoc",
        enterpriseId: this.enterpriseId
      };
      docService.addPersonFavorite(param).then(res => {
        if (res.result === "0") {
          this.$store.dispatch("perFileUpdateNodeList");
          this.$message.success("收藏成功");
          this.querlist2(this.currentNode.folderId);
          this.$store.dispatch("perFileUpdateMessageObj", {
            isShow: false,
            message: ""
          });
        }
      });
    },

    // 点击文件名称
    async clickFolderFile(row, event) {
      const { isFolder } = row;
      if (isFolder === 1) {
        this.$store.dispatch("perFileUpdateTreeNodeDan", row);
        this.navArr.push(row);
        this.$store.dispatch("perFileUpdateNavDan", this.navArr);
      } else {
        if (isFolder === 1) {
          return;
        } else if (row.isDelete === 1) {
          this.$message.warning("该文件已删除，无法查看");
        } else {
          this.viewFile(row, event);
        }
      }
    },

    async viewFile(row, event) {
      this.onLineView(row);
    },

    async onLineView(row) {
      const { status, folderId: fileId, fileVersion: versionId, parentId, fileType } = row;
      const data = { status, fileId, versionId, parentId, fileType };
      filePreviewV1(data, this.list);
    },

    async downloadFile(row) {
      const prjId = "EnterpriseDeptDoc";
      const userInfo = this.userInfo;
      const { userId, token } = userInfo;
      if (row.isFolder !== 1) {
        const fileId = row.folderId;
        const downzipurl = downloadUrlNoPermissiontoken(prjId, fileId, token);
        downloadFile(downzipurl);
      } else {
        var params = {
          folderId: row.folderId,
          rootDirectory: row.folderName,
          prjId: prjId,
          enterpriseId: this.enterpriseId,
          userId: userId
        };
        console.log(params);
        docService.downloadfolder(params).then(response => {
          const fileName = row.folderName + ".zip";
          if ("msSaveOrOpenBlob" in navigator) {
            // 兼容ie
            // var blob = response
            window.navigator.msSaveOrOpenBlob(response, fileName);
            return;
          } else {
            const link = document.createElement("a");
            const blob = response;
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
      }
    },

    async rechristen({ $index, row }) {
      this.isShowRechristen = [];
      if (row.isFolder === 1) {
        this.rechristenCommitName = row.folderName;
      } else {
        const typeIndex = row.folderName.lastIndexOf(".");
        const newName = row.folderName.substring(0, typeIndex);
        this.rechristenCommitName = newName;
      }
      this.isShowRechristen[$index] = true;
      this.$set(this.isShowRechristen, $index, true);
      this.$nextTick(() => {
        const ref = "input" + row.folderId;
        this.$refs[ref].focus();
      });
    },

    async commit(row) {
      let name = this.rechristenCommitName.replace(/\s*/g, "");
      if (!name || name.length < 1 || name.length > 80) {
        return this.$message.warning("名字不能为空且不超过80个字符");
      }
      const { isFolder } = row;
      var id = row.folderId;
      const prjId = this.enterpriseId;
      var remark = "";
      if (row.isFolder === 0) {
        const fileTypeArr = row.folderName.split(".");
        name = `${name}.${fileTypeArr[fileTypeArr.length - 1]}`;
      }
      await docService.renameMyDoc({ name, id, remark, isFolder, prjId });
      this.isShowRechristen = [];
      this.$message.success("修改成功");
      this.querlist2(this.currentNode.folderId);
    },

    updateLight(row, type) {
      const prjId = this.enterpriseId;
      row.status = "1";
      const status = row.status;
      let messageType;
      type === 1 ? (messageType = "优先轻量化操作") : (messageType = "重新轻量化操作");
      docService
        .updateLight(prjId, row.folderId, row.fileVersion)
        .then(res => {
          if (res.result === "0") {
            row.status = "1";
            this.$message.success(`${messageType}成功`);
          } else {
            row.status = status;
            this.$message.warning(`${messageType}失败`);
          }
        })
        .catch(() => {
          row.status = status;
        });
    },

    handleBeforeUpload(file) {
      const lastObj = this.qinglianghuaList[this.qinglianghuaList.length - 1];
      const uploadFileName = this._splitFileName(file.name);
      const rvtFileName = this._splitFileName(lastObj.folderName);
      if (uploadFileName !== rvtFileName) {
        this.$message({
          message: `请选择和${lastObj.fileType === 7 ? "rvt" : "skp"}文件匹配的轻量化文件`,
          type: "warning",
          duration: 2000,
          showClose: true
        });
        return false;
      }
      // const rvtId = lastObj.folderId;
      lastObj.status = "1";
      this.$message.success("操作成功,正在轻量化");
    },

    _splitFileName(text) {
      const pattern = /\.{1}[a-zA-Z]{1,}$/;
      if (pattern.exec(text) !== null) {
        return text.slice(0, pattern.exec(text).index);
      } else {
        return text;
      }
    },

    _splitFileType(text) {
      const lastIndex = text.lastIndexOf(".");
      return text.substring(lastIndex + 1);
    },

    handleAvatarSuccess(response, file, fileList) {
      let status;
      let message;
      let type;
      if (response.data.code === 0) {
        status = "2";
        message = "文件轻量化成功";
        type = "success";
      } else {
        status = "";
        message = response.data.msg || "轻量化失败,请重新轻量化";
        type = "warning";
      }
      const rvtId = response.data.rvtId;
      const obj = this.qinglianghuaList.find(item => item.folderId === rvtId);
      obj.status = status;
      this.$message({
        message: message,
        type: type,
        duration: 2000,
        showClose: true
      });
      const index = this.qinglianghuaList.findIndex(item => item.folderId === rvtId);
      if (index > -1) {
        this.qinglianghuaList.splice(index, 1);
      }
    },

    handleError() {
      this.$message({
        message: "文件轻量化失败,请重新轻量化",
        type: "warning",
        duration: 2000,
        showClose: true
      });
    },

    async gently(scope) {
      const { row } = scope;
      this.qinglianghuaList.push(row);
      if (row.fileType === 7) {
        this.accept = ".bimex";
      } else {
        this.accept = ".bimex,.usdp";
      }
      const prjId = this.enterpriseId;
      const rvtId = row.folderId;
      const rvtVersion = row.fileVersion;
      this.actionUrl = gentlyUrl(rvtId, prjId, rvtVersion);
      this.$nextTick(() => {
        const gentlyBtn = document.getElementById("gentlyBtn");
        if (gentlyBtn) {
          gentlyBtn.click();
        }
      });
    },

    async deleteRow(row) {
      const folderId = row.folderId;
      try {
        this.$confirm("确定删除吗?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
          .then(async () => {
            this.$store.dispatch("perFileUpdateMessageObj", {
              isShow: true,
              message: "删除中..."
            });
            const result = await secondaryMenuService.queryDeleteNoPermissionFile([folderId]);
            if (result.result === "0") {
              this.querlist2(folderId);
              this.$store.dispatch("perFileUpdateMessageObj", {
                isShow: false,
                message: ""
              });
              this.$message({ type: "success", message: "删除成功" });
            }
          })
          .catch(() => {});
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: false,
          message: ""
        });
      }
    },

    isFinalGently(row) {
      return row.fileType === 7 || row.fileType === 18 || row.fileType === 19;
    },

    clickRow(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },

    selectChange(selection) {
      this.$store.dispatch("XtDesignUpdateSelect", selection);
    },

    formatterFileSize(row, column) {
      if (row.fileSize === "0B") {
        return "-";
      } else {
        return row.fileSize;
      }
    },

    className(row) {
      return tableRowIcon(row);
    },

    searchFolderExpand(val) {
      if (val.length) {
        var arr = val[val.length - 1];
        this.$store.dispatch("perFileUpdateTreeNodeDan", arr);
        // this.argument1.folderId = arr.folderId;
        this.querlist2(arr.folderId);
      }
    },
    parent2(val) {
      this.querlist2(val);
    },
    blur() {
      setTimeout(() => {
        this.isShowRechristen = [];
      }, 500);
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
#EnterpriseDeptDocfileTable {
  width: 100%;
  height: 1px;
  flex-grow: 1;
  padding: 0px var(--big-space) var(--middle-space);

  /deep/ .el-table {

    .el-table__body-wrapper {
      .rowIcon {
        cursor: pointer;
        color: #A1C5E7;
        font-size: 16px;
        margin-right: 6px;
      }
    }

    .el-table__body-wrapper::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-track {
      background: rgb(255, 255, 255);
      border-radius: 2px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: #eee;
      border-radius: 10px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background: #C4C6CC;
    }
  }
}
</style>
